import React from "react";
import { FaUserCircle, FaFileAlt, FaEnvelope } from "react-icons/fa";

const dummyApplications = [
  {
    id: 1,
    name: "Jane Doe",
    email: "jane.doe@example.com",
    position: "Marketing Manager",
    appliedDate: "May 26, 2025",
    resumeLink: "#",
  },
  {
    id: 2,
    name: "John Smith",
    email: "john.smith@example.com",
    position: "Frontend Developer",
    appliedDate: "May 25, 2025",
    resumeLink: "#",
  },
];

const EmployerCandidates = () => {
  return (
    <div className="flex-1 bg-[#f9fafb] p-6 min-h-screen">
      <h1 className="text-2xl font-semibold text-gray-800 mb-6">Candidates</h1>

      {dummyApplications.length === 0 ? (
        <p className="text-gray-500">No applications received yet.</p>
      ) : (
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
          <table className="w-full text-sm text-left text-gray-700">
            <thead className="bg-gray-100 text-gray-800 text-sm font-medium">
              <tr>
                <th className="px-6 py-3">Candidate</th>
                <th className="px-6 py-3">Email</th>
                <th className="px-6 py-3">Job Title</th>
                <th className="px-6 py-3">Applied On</th>
                <th className="px-6 py-3">Resume</th>
              </tr>
            </thead>
            <tbody>
              {dummyApplications.map((app) => (
                <tr key={app.id} className="border-t hover:bg-gray-50">
                  <td className="px-6 py-4 flex items-center gap-3">
                    <FaUserCircle className="text-2xl text-gray-500" />
                    {app.name}
                  </td>
                  <td className="px-6 py-4 flex items-center gap-2">
                    <FaEnvelope className="text-gray-400" />
                    {app.email}
                  </td>
                  <td className="px-6 py-4">{app.position}</td>
                  <td className="px-6 py-4">{app.appliedDate}</td>
                  <td className="px-6 py-4">
                    <a
                      href={app.resumeLink}
                      className="flex items-center gap-2 text-blue-600 hover:underline"
                    >
                      <FaFileAlt />
                      View Resume
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default EmployerCandidates;
